import { memo } from 'react';
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';
import { useGetStudentOfYear } from '../../../hooks/query/useGetStudentOfYear';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function MonthlyRevenue() {
    const currentYear = new Date().getFullYear();
    const { data, isLoading } = useGetStudentOfYear({ year: currentYear });

    // data.data = { year, total, data: [{month: 1, count: 10}, ...] }
    const response = data?.data;
    const monthlyData: { month: number; count: number }[] = response?.data ?? [];

    const chartData = MONTHS.map((month, index) => {
        const found = monthlyData.find((d) => d.month === index + 1);
        return {
            month,
            value: found?.count ?? 0,
        };
    });

    const totalStudents = response?.total ?? 0;
    const nonZeroMonths = chartData.filter((item) => item.value > 0);
    const average = nonZeroMonths.length > 0
        ? Math.round(totalStudents / nonZeroMonths.length)
        : 0;
    const maxMonth = chartData.reduce((max, item) => item.value > max.value ? item : max, chartData[0]);

    return (
        <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50">
            <h3 className="text-white text-lg font-semibold mb-4">
                Thống kê học sinh đăng ký năm {currentYear}
            </h3>

            {isLoading ? (
                <div className="flex items-center justify-center h-[200px]">
                    <p className="text-slate-400 text-sm">Loading...</p>
                </div>
            ) : (
                <>
                    <ResponsiveContainer width="100%" height={200}>
                        <BarChart data={chartData}>
                            <Bar dataKey="value" fill="#06b6d4" radius={[8, 8, 0, 0]} />
                            <XAxis
                                dataKey="month"
                                stroke="#64748b"
                                style={{ fontSize: '12px' }}
                                tickLine={false}
                                axisLine={false}
                            />
                            <Tooltip
                                cursor={{ fill: 'rgba(255,255,255,0.05)' }}
                                contentStyle={{ background: '#1e293b', border: 'none', borderRadius: 8 }}
                                labelStyle={{ color: '#94a3b8' }}
                                itemStyle={{ color: '#06b6d4' }}
                                formatter={(value: number | undefined) => [value ?? 0, 'Students']}
                            />
                        </BarChart>
                    </ResponsiveContainer>

                    <div className="mt-4">
                        <p className="text-slate-400 text-sm">
                            Average monthly enrollment in {currentYear}
                        </p>
                        <div className="flex items-center gap-4 mt-2">
                            <span className="text-3xl font-bold text-blue-400">{average}</span>
                            <div className="flex flex-col">
                                <span className="text-white text-sm font-medium">
                                    {totalStudents} total
                                </span>
                                <span className="text-emerald-400 text-xs">
                                    Peak: {maxMonth?.month} ({maxMonth?.value}) ↑
                                </span>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default memo(MonthlyRevenue);